import { appConstants } from '@plugin/Common/constants/cross-sell/app.constants'
import { LocalStorageServiceInterface } from '@plugin/Common/interfaces/cross-sell/local-storage-service.interface'

class LocalStorageService implements LocalStorageServiceInterface {
  private readonly storageKey: string

  constructor(storageKey: string) {
    this.storageKey = storageKey
  }

  public removeProductViewCount(productId: number): void {
    this.updateProductViewCount(productId, 0)
  }

  public removeAllProductViewCounts(): void {
    window.localStorage.removeItem(this.storageKey)
  }

  public getProductViewCount(productId: number): number {
    let output = 0
    const storageJson = window.localStorage.getItem(this.storageKey)
    const storage = storageJson ? JSON.parse(storageJson) : {}
    if (storage && storage.records) {
      const productRecord = storage.records.find((x) => x.productId === productId)
      if (productRecord) {
        output = productRecord.addToCartLightboxCount
      }
    }
    return output
  }

  public updateProductViewCount(productId: number, viewCount: number): void {
    const storageJson = window.localStorage.getItem(this.storageKey)
    const storage = storageJson ? JSON.parse(storageJson) : {}
    if (storage && storage.records) {
      const productRecordIndex = storage.records.findIndex((x) => x.productId === productId)
      if (productRecordIndex > -1) {
        storage.records[productRecordIndex].addToCartLightboxCount = viewCount
      }
    } else {
      storage.records = [
        {
          productId,
          addToCartLightboxCount: viewCount,
        },
      ]
    }
    window.localStorage[this.storageKey] = JSON.stringify(storage)
  }
}

const localStorageService = new LocalStorageService(appConstants.sessionStorageKey)
export { localStorageService, LocalStorageService }
